import React from 'react';
import { useSelector } from 'react-redux';
import SingleMap from '../../../fragments/map/singleMap';
import DirectionsIcon from '@mui/icons-material/Directions';
export const EventMap = () => {
    const event = useSelector((state) => state.events.eventById);

    return (
        <div className="details-white-box" style={{ padding: 0 }}>
            <div className="event-map-section">
                <SingleMap address={event?.address} />
                {event?.address && (
                    <div className="map-details">
                        <p className="community">{event?.address?.city}</p>
                        {/*<p className="formatted-address">{event?.address?.formattedAddress}</p>*/}
                        <a href={`https://www.google.com/maps?saddr=My+Location&daddr=${event?.address?.lat},${event?.address?.lng}`}
                           rel="noreferrer"
                           target={'_blank'}
                           className='flex-start' style={{color:'black'}}
                        >
                            <DirectionsIcon style={{marginRight: 4, marginTop: '-4px'}}/>
                            {event?.address?.formattedAddress}
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};
